export default __webpack_public_path__ + "static/media/1.07245437.jpeg";